
export const ERROR_MESSAGE = {
    EMAIL_ALREADY_EXISTS:"The specified email already exists. Please try with another email.",
    TECHNICAL_ISSUE:"Technical issue. Please try again in some time."
}